import React, { FC } from 'react';
import { Icon } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import dayjs from 'dayjs';
import { ISocialWorkExperience } from '@src/types/resumeDetail/socialType';
import { ICampusWorkExperience } from '@/src/types/resumeDetail/campusType';

import './index.scss';

interface IProps {
  data: ISocialWorkExperience[] | ICampusWorkExperience[];
  type: string;
  setMode: Function;
}
// 社校共用
const WorkExperienceView: FC<IProps> = (props) => {
  const { data, type, setMode } = props;
  const { campusResumeFormRefStore, socialResumeFormRefStore } = useRootStore();
  let storeRef;
  if (type === 'campus') {
    storeRef = campusResumeFormRefStore;
  }
  if (type === 'social') {
    storeRef = socialResumeFormRefStore;
  }

  const handleEdit = () => {
    setMode('edit');
    storeRef.setCurrentScrollRef('work_experience_edit');
  };
  return (
    <div className="work_experience_view model_view">
      <div className="model_title">
        <div>工作/实习经历</div>
        <div className="edit_icon" onClick={() => handleEdit()}>
          <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
        </div>
      </div>
      {/* @ts-ignore */}
      {data?.map((item) => (
        <div className="model_list" key={item.renderId}>
          <div className="model_top">
            <div className="company_name">{item.companyName}</div>
            <div className="company_time">
              {dayjs(item.startDate).isValid() ? dayjs(item.startDate).format('YYYY/MM') : ''}-
              {/* eslint-disable-next-line no-nested-ternary */}
              {item.endDate === 253370736000000
                ? '至今'
                : dayjs(item.endDate).isValid()
                  ? dayjs(item.endDate).format('YYYY/MM')
                  : ''}
            </div>
          </div>
          <div className="model_line" />
          <div className="model_bottom">
            <div className="first_line line">
              <div className="label">
                <span className="title">部门名称：</span>
                <span className="content">{item.department || '-'}</span>
              </div>
              <div className="label">
                <span className="title">职位名称：</span>
                <span className="content">{item.position}</span>
              </div>
              <div className="label">
                <span className="title">工作类型：</span>
                <span className="content">{item.workTypeName}</span>
              </div>
            </div>
            <div className="second_line">
              <div className="label">
                <div className="label_left">工作描述：</div>
                <div className="label_right">{item.workDescription || '-'}</div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WorkExperienceView;
